// extracted by mini-css-extract-plugin
module.exports = {"container":"_2JQf8","actions":"nPyZ5"};